<template>
    <modals-generic
    smallIcon="map-agency"
    :title="agencyDetails.name"
    :subTitle="t('agencies.detailsModal.agency')"
	invertTitleSubtitle
    @hideMe="emit('hideMe')">
        <div class="agency-details" :class="{'mobile-styles': getMobileAppState}">
            <!-- Agency Address -->
            <divider-generic
            icon="pin-drop"
            :applyBorder="false"
            :dividerSize="'medium'"
            :title="t('agencies.detailsModal.address')"/>
            <div class="map-container">
                <!-- Agency Map -->
                <agencies-map
                useAgencyLocation
                :agenciesList="agencyLocation"
                :agencyLocation="{latitude: agencyDetails.coordinates.latitude, longitude: agencyDetails.coordinates.longitude}"
                :useMyCurrentLocation="useMyCurrentLocation"/>
            </div>
            <text-block-location :params="addressParams"/>
            <div v-if="phoneNumbers[0].length" class="agencies-contacts">
                <!-- Agency Contacts -->
                <divider-generic
                icon="phone"
                :dividerSize="'medium'"
                :applyBorder="!getMobileAppState"
                :title="t('agencies.detailsModal.contacts')"/>
                <text-block-phone
                v-for="(number, index) in phoneNumbers"
                :key="index"
                :params="{
                    phoneNumber: number,
                    mask: PHONE_NUMBER_WITH_3_INDICATIVE
                }"/>
            </div>
            <!-- Agency Schedule -->
            <divider-generic
            icon="clock"
            :dividerSize="'medium'"
            :applyBorder="!getMobileAppState"
            :title="t('agencies.detailsModal.schedule')"/>
            <text-block-generic :params="params"  applyEllipsis/>
        </div>
    </modals-generic>
</template>

<script setup>
import ModalsGeneric from '@/components/generic/modals/side/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import TextBlockPhone from '@/components/generic/textBlocks/Phone'
import TextBlockLocation from '@/components/generic/textBlocks/Location'
import AgenciesMap from '@/components/features/agencies/AgenciesMap'

/* Vue & Helpers */
import { ref, computed } from 'vue'
import { PHONE_NUMBER_WITH_3_INDICATIVE } from '@/assets/constants/masks'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['hideMe'])

const props = defineProps({
    agencyDetails: Array,
    agenciesList: Array
})

const addressParams = ref({
    content: `${props.agencyDetails.address.address}, ${props.agencyDetails.address.city.toLowerCase().charAt(0).toUpperCase() + props.agencyDetails.address.city.toLowerCase().slice(1)}`,
    directions: `https://www.google.com/maps/dir/?api=1&destination=${props.agencyDetails.coordinates.latitude},${props.agencyDetails.coordinates.longitude}`
})

const phoneNumbers = computed(() => {
    return props.agencyDetails.phoneNumber.split('/')
})

const params = computed(() => {
    const openingDays = props.agencyDetails.schedules[0].description
    const openingTime = props.agencyDetails.schedules[0].openTime
    const closingTime = props.agencyDetails.schedules[0].closeTime

    return {
        content: t('agencies.detailsModal.scheduleTime', { openingDays: openingDays, openingTime: openingTime, closingTime: closingTime })
    }
})

const agencyLocation = computed(() => {
    const agencyList = []

    agencyList.push(props.agencyDetails)

    return agencyList
})
</script>

<style lang="scss" scoped>
.agency-details {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    gap: 24px;

    .agencies-contacts {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .text-blocks-wrapper {
        max-height: 42px;
    }

    .map-container {
        width: 100%;
        min-height: 203px;

        position: relative;

        :deep(#map-static-wrapper) {
            width: 513px !important;
            height: 100%;
        }

    }

    &.mobile-styles {
        padding: 0 16px 16px 16px;
        .map-container {
            :deep(#map-static-wrapper) {
                width: 360px !important;
            }

        }
    }
}

</style>
